import { render, staticRenderFns } from "./chemDept.vue?vue&type=template&id=329f0b65"
import script from "./chemDept.vue?vue&type=script&lang=js"
export * from "./chemDept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('329f0b65')) {
      api.createRecord('329f0b65', component.options)
    } else {
      api.reload('329f0b65', component.options)
    }
    module.hot.accept("./chemDept.vue?vue&type=template&id=329f0b65", function () {
      api.rerender('329f0b65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/chemDept.vue"
export default component.exports